<template>
     <span v-if="hasTranslation">
      
      <v-switch
                v-bind="$attrs"
                v-model="switchStatus"
                :label="labelText"
                :hint="hintText"
                :loading="loading"
                :persistent-hint="persistentHint"
                :active="active"
                :autofocus="autofocus"
                :bg-color="bgColor"
                :base-color="baseColor"
                :variant="variant"
                :true-value="trueValue"
                :false-value="falseValue"
                :density="density"
                @input="$emit('update:modelValue', $event.target.value)" 
              />
              <!--  :modelValue="modelValue"
                              @update:modelValue="updateModel"

                    @input="$emit('update:modelValue', $event.target.value)" -->
    </span>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState, mapGetters } from 'pinia'
import { defineModel } from 'vue'

// import { defineAsyncComponent } from 'vue'

export default {
  name: 'I18nSwitch',
  components: {},
//  emits: ['update:modelValue'],
  props: {
    modelValue: {},
    i18nlabel: {
        type: String,
        required: true
    },
    i18nhint: {
        type: String,
        required: false,
        default: ''
    },
    persistentHint: {
        type: Boolean,
        required: false,
        default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
        type: Boolean,
        required: false,
        default: true
    },
    autofocus: {
        type: Boolean,
        required: false,
        default: false
    },
    bgColor: {
        type: String,
        required: false,
        default: 'var(--color-white)'
    },
    baseColor: {
        type: String,
        required: false,
        default: 'var(--color-white)'
    },
    variant: {
        type: String,
        required: false,
        default: 'solo'
    },
    trueValue: {
      type: Boolean,
      required: false,
      default: true
    },
    falseValue: {
      type: Boolean,
      required: false,
      default: false
    },
    density: {
      type: String,
      required: false,
      default: 'comfortable'
    }
  },
  data() {
    return {
        labelText: '',
        hintText: '',
        hasTranslation: false,
        inputValue: '', //defineModel(),
        value: '',
        switchStatus: ''
    }
  },
  beforeMount() {
    console.log('i18nSWITCH GOT BEFORE MOUNT !')
  },
  mounted() {
    console.log('i18nSWITCH GOT BEFORE MOUNT ! Label (%s)', this.i18nlabel)
    // console.log('HINT (%s)', this.i18nhint)
      this.geti18nTranslation(this.i18nlabel).then(result => {
      //  console.log('i18nSWITCH TRANSLATE TEXT (%s)', result)
            this.labelText = result
            this.geti18nTranslation(this.i18nhint).then(res2 => {
              this.hintText = res2
              this.hasTranslation = true
            })
       })
  },
  methods: {
    ...mapActions(adminStore, ['geti18nTranslation']),
    ...mapGetters(adminStore,['getTranslationMap']),
    updateModel() {
      console.log('updateModel got called (%s)', this.switchStatus)
      this.$emit('update:modelValue', this.switchStatus)
    }
  }
}
</script>

<style scoped>

</style>